
import CreativeLib from '../../components/creativeLib.vue';

export default {
  components: {
    CreativeLib: CreativeLib
  }
};